module.exports = __webpack_public_path__ + "static/m_ilyin-50050fcd789b538793c6e941937a7b54.jpg";